import React from 'react'
import arrowBtn from './../../UI/general/Icon_Show-Hide.svg'
import GETWebParams from '../../helpers/GETWebParams';
import { getVersionDisplayName } from '../../helpers/strapi.helper';

import Switch from "react-switch";

const params = GETWebParams()

interface Props {
  showCaracteristics: boolean,
  showViews: boolean,
  showSeats?: boolean,
  versionsToShow: any,
  currentVersionSelected: string,
  currentCarSelected: string,
  resetMenus: boolean,
  handleChangeMenu: (payload: number) => void,
  handleShowInterior: (payload: boolean) => void 
  handleShowBullets: (payload: boolean) => void
  handleShowBulletsInterior: (payload: boolean) => void
  isPlayingAnimation: boolean
//Extended
  colorsToShow: any,  
  currentColorSelected: string,
  handleChangeColor: (payload: string) => void

  currentSeatSelected: number,
  handleChangeSeat: (payload: number) => void
  seatRows: number,
  scenesData: any,
  handleChangeScene: (payload: any) => void
  currentSceneSelected: any,
  handleCloseAllMenus: () => void
}

interface State {
  currentVistaSelected: number,
  showBullets: boolean,

  currentColorSelected: string,
  currentSceneSelected: number
}

class Caracteristicas extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentVistaSelected: 0,
      showBullets: false,

      currentColorSelected: this.props.currentColorSelected,
      currentSceneSelected: 0
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.currentColorSelected !== prevProps.currentColorSelected){
      this.setState({
        currentColorSelected: this.props.currentColorSelected
      })
    }
    if(prevProps.currentSceneSelected !== this.props.currentSceneSelected){
      console.log(this.props.currentSceneSelected.name)
      Object.keys(this.props.scenesData).forEach((scenes: string, index: number) => {
        if(this.props.scenesData[scenes].name === this.props.currentSceneSelected.name){
          this.setState({
            currentSceneSelected: index
          })
        }
      })
    }
    if(prevProps.resetMenus !== this.props.resetMenus){
      this.resetMenu()
    }
  }

  resetMenu = () => {
    if(this.props.resetMenus === true){
      console.log("reset menu")
      this.setState({
        currentVistaSelected: 0,
        showBullets: false,

        currentSceneSelected: 0,
        currentColorSelected: this.props.currentColorSelected,
      }, () => {
        this.props.handleChangeMenu(0)
        this.props.handleShowInterior(false)
        this.props.handleShowBulletsInterior(false)
        this.props.handleShowBullets(false)
      })
    }
  }

  render(): React.ReactNode {
      return(
        <div className={!this.props.showCaracteristics ? 'caracteristics-mobile-collapsed':'caracteristics-mobile-opened'}>

          {
            this.props.showCaracteristics && 
            <div className='caracteristics-close-button' onClick={() => {this.props.handleCloseAllMenus()}}>
              <img src={arrowBtn} alt=''/>
            </div>
          }

          <div className='caracteristics-version-container-mobile'>
            <div className='version-title-mobile'>
              Versiones
            </div>
            <div className='car-studio-versions-container-mobile'>
                  {
                    Object.keys(this.props.versionsToShow).map((version: any, index: number) => 
                    <div className={this.props.currentVersionSelected === version ? 'car-studio-version-individual-mobile version-selected-mobile':'car-studio-version-individual-mobile'}>{getVersionDisplayName(this.props.currentCarSelected, version)}</div>
                    )
                  }
                </div>
          </div>
          {this.props.showViews &&
          <div className='caracteristics-version-container-mobile'>
            <div className='version-title-mobile'>
              Vistas
            </div>
            <div className='vistas-container-mobile'>
            <div 
            className={this.state.currentVistaSelected === 0 ? 'vistas-individual-container-mobile vista-selected-mobile':'vistas-individual-container-mobile'}
            onClick={() => {
              if (!this.props.isPlayingAnimation && this.state.currentVistaSelected !== 0) {
                this.setState({
                  currentVistaSelected: 0,
                  showBullets: false,
                }, () => {
                  this.props.handleChangeMenu(0)
                  this.props.handleShowInterior(false)
                  this.props.handleShowBulletsInterior(false)
                  this.props.handleShowBullets(false)
                })
              }
              
            }}
            >
              Exterior
            </div>
            <div 
            className={this.state.currentVistaSelected === 1 ? 'vistas-individual-container-mobile vista-selected-mobile':'vistas-individual-container-mobile'}
            onClick={() => {
              if (!this.props.isPlayingAnimation && this.state.currentVistaSelected !== 1) {
                this.setState({
                  currentVistaSelected: 1,
                  showBullets: false,
                }, () => {
                  this.props.handleChangeMenu(1)
                  this.props.handleShowInterior(true)
                  this.props.handleShowBulletsInterior(false)
                  this.props.handleShowBullets(false)
                })
              }
            }}
            >
              Interior
            </div>
          </div>
          </div>
          }

          { params.lite !== "true" ?
            <div className='switch-car-studio-caracteristic-container'>
            <Switch 
              onChange={() => {
                this.setState({
                  showBullets: !this.state.showBullets
                }, () => {
                  this.state.currentVistaSelected === 1 ?
                  this.props.handleShowBulletsInterior(this.state.showBullets):
                  this.props.handleShowBullets(this.state.showBullets)
                })
              }} 
              offColor = '#000000'
              onColor = '#000000'
              onHandleColor = {'#05A3E1'}
              offHandleColor = {'#ffffff'}
              checked={this.state.showBullets}
              uncheckedIcon = {false}
              checkedIcon = {false}
              activeBoxShadow = {'0px 0px 3px #05A3E1'}
              handleDiameter={16}
              height={23}
              width={42}
              className='switch-input'
            />
            <div className='switch-car-studio-title'>Mostrar características</div>
          </div>
          :
          <div style={{marginTop: "2rem"}}/>
          }

          <hr className='hr-caracteristicas-mobile'/>
          
          {
            <div className='escenarios-container-mobile'>
            <div className='escenarios-container-title-mobile'>
              Escenarios
            </div>
            <div className='scenes-general-container-mobile'>
              {
                Object.keys(this.props.scenesData).map((scenes: any, index: number) => 
                  <div className='scenes-individual-container-text'>
                    <div 
                    className={this.state.currentSceneSelected === index ? 'scenes-individual-container-mobile color-selected':'scenes-individual-container-mobile'}
                    onClick={() => {
                      this.setState({
                        currentSceneSelected: index
                      }, () => {
                        this.props.handleChangeScene(this.props.scenesData[scenes])
                      })
                    }}
                    >
                      <img src={this.props.scenesData[scenes].icon.default} alt=''/>
                    </div>
                    <div className='scenes-individual-text'>{this.props.scenesData[scenes].name}</div>
                  </div>
                )
              }
            </div>
          </div>
          }

          {/* { this.state.currentVistaSelected === 0 && <hr className='hr-caracteristicas-mobile'/>} */}
          { this.state.currentVistaSelected === 0 &&
            <div className='color-container-mobile' style={{marginTop: '1rem'}}>
            <div className='color-container-title' >
              Color
            </div>
            <div className='color-general-container-mobile'>
            {
                    Object.keys(this.props.colorsToShow).map((color: any) =>
                      <div 
                        className={this.state.currentColorSelected === color ? 'colors-individual-container color-selected':'colors-individual-container'} 
                        style={{
                          backgroundImage: `url(${this.props.colorsToShow[color].Image})`
                        }}
                        onClick={() => {
                          this.setState({
                            currentColorSelected: color
                          }, () => {
                            this.props.handleChangeColor(color)
                          })
                        }}
                      >
                        <img src={this.props.colorsToShow[color].Image} alt=''/>
                      </div>
                    )
                  }
            </div>
            <div className='color-current-mobile'>
              {this.state.currentColorSelected !== '' && this.props.colorsToShow[this.state.currentColorSelected] ? this.props.colorsToShow[this.state.currentColorSelected].name: this.props.currentColorSelected !== '' && this.props.colorsToShow[this.props.currentColorSelected] ? this.props.colorsToShow[this.props.currentColorSelected].name:''}
            </div>
            </div>
          }

          { this.state.currentVistaSelected === 1 && <hr className='hr-caracteristicas-mobile'/>}
          { this.state.currentVistaSelected === 1 && this.props.showSeats !== false &&
            <div className='seat-container-mobile'>    
            <div className='seat-container-title-mobile'>Distribución de sillas</div>
            {this.props.seatRows === 1 && //1 seat rows
              <div className='seat-general-container-mobile'>
              <div 
                className={this.props.currentSeatSelected === 0 ? 'seat seat-front-left seat-selected':'seat seat-front-left'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(0) }
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 1 ? 'seat seat-front-right seat-selected':'seat seat-front-right'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(1) }
                  
                }}
              />
            </div>}
            {this.props.seatRows === 2 && //2 seat rows
              <div className='seat-general-container-mobile'>
              <div 
                className={this.props.currentSeatSelected === 0 ? 'seat seat-front-left seat-selected':'seat seat-front-left'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(0) }
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 1 ? 'seat seat-front-right seat-selected':'seat seat-front-right'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(1) }
                  
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 2 ? 'seat seat-back-left seat-selected':'seat seat-back-left'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(2) }
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 3 ? 'seat seat-back-right seat-selected':'seat seat-back-right'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(3) }
                }}
              />
            </div>}
            {this.props.seatRows === 3 && //3 seat rows
              <div className='seat-general-container-mobile'>
              <div 
                className={this.props.currentSeatSelected === 0 ? 'seat seat-front-left seat-selected':'seat seat-front-left'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(0) }
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 1 ? 'seat seat-front-right seat-selected':'seat seat-front-right'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(1) }
                  
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 2 ? 'seat seat-middle-left seat-selected':'seat seat-middle-left'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(2) }
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 3 ? 'seat seat-middle-right seat-selected':'seat seat-middle-right'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(3) }
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 4 ? 'seat seat-back-left seat-selected':'seat seat-back-left'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(4) }
                }}
              />
              <div 
                className={this.props.currentSeatSelected === 5 ? 'seat seat-back-right seat-selected':'seat seat-back-right'}
                onClick={() => {
                  if (!this.props.isPlayingAnimation) { this.props.handleChangeSeat(5) }
                }}
              />
            </div>}
          </div>
          }


            <hr className='hr-caracteristicas-mobile'/>

        </div>
      )
  }
}

export default Caracteristicas